import React,{useCallback, useEffect, useRef}  from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

import {useSelector,useDispatch} from 'react-redux'
import {
  getCID,
  getCurrentStep,
  getDataFromURL
} from '../../../utilities/function/urlparams'

import {
  getAttributes
} from '../../../utilities/function/configuration'

import {
  getPriceByBillingCycleName
} from "../../../utilities/function/billingCycle"

import ProductSidebar from '../../shared/sidebar/productsidebar'
import PageSlider from '../../shared/pageslider'
import { updateConfig } from '../../../app/action'
import Breadcrumbs from '../../shared/breadcrumbs'
import SelectHostingDomain from '../../shared/steps/selecthostingdomain'
import CloseButton from '../../shared/closebutton'
import SelectConfigOptions from '../../shared/steps/selectconfigoptions'
import {usePageCallback} from "../../../utilities/function/page";

let GSuite = props =>{
  const {location} =  props
  const { configurations } = useSelector(state=>({
    configurations: state.app.configurations,

  }))
  const cid = getCID(getDataFromURL(location.search))
  const step = getCurrentStep(configurations,cid)
  const dispatch = useDispatch()
  const {getAdditionalOptionsData} = usePageCallback()
  const getBreadcrumbsData = useCallback(() => {
    const list = [{
      label: 'Domain Name',
      itemStep: 0,
      configKey: 'name'
    },{
      label: 'Resources',
      itemStep: 1,
      configKey: 'config'
    }]
    const addonData = getAdditionalOptionsData()
    if(addonData && addonData.length > 0){
      list.push({
        label: 'Addons',
        itemStep: 2,
        configKey: 'addons'
      })
    }
    return list
  },[getAdditionalOptionsData])
  const prevStep = useRef(null)
  const initRef = useRef(false)
  const initCallback = useCallback(()=>{
    if(!initRef.current){
      if (configurations[cid] && configurations[cid].selectedProduct) {
        const {price} = getAttributes(configurations[cid].selectedProduct)
        const monthly = getPriceByBillingCycleName(price, "Monthly")
        updateConfig(configurations, cid, {
          billing_cycle_id: monthly.billing_cycle_id,
        }, dispatch)
        initRef.current = true
      }
    }
  },[initRef,dispatch,configurations,cid])
  const resetStepCallback = useCallback(()=>{
    if(prevStep.current !== step){
      const newStep = step > 1 ? 1 : step
      updateConfig(configurations,cid,{
        step: newStep
      },dispatch)
      prevStep.current = step
    }

  },[step,prevStep,configurations,cid,dispatch])
  useEffect(()=>{
    initCallback()
    resetStepCallback()
  },[resetStepCallback,initCallback])
  return (
    <div className={'of-gsuite of-page clearfix'}>
      <div className={'of-page__wrapper'}>
        <PageSlider step={step}>
          <Breadcrumbs data={getBreadcrumbsData()} step={step} cid={cid} />
          <SelectHostingDomain showOn={0} cid={cid} />
          <SelectConfigOptions />
          <CloseButton />
        </PageSlider>
        <ProductSidebar />
      </div>
    </div>
  )
}

GSuite.propTypes = {
  location: PropTypes.object
}

GSuite = withRouter(GSuite)



export default GSuite